"use client";

import BaseCartModal from "../../shared/cart/base-cart-modal";
import CartCheckout, { CartSummary } from "./cart-checkout";
import DeliveryMethod from "./delivery-method";
import FinalCheckout from "./final-checkout";
import PopUp from "../product/popUp";
import styles from "../index.module.scss";
import UserInfo from "./userInfo";

const CartModal = (props) => (
  <BaseCartModal
    {...props}
    styles={styles}
    CartCheckout={CartCheckout}
    CartSummary={CartSummary}
    DeliveryMethod={DeliveryMethod}
    FinalCheckout={FinalCheckout}
    UserInfo={UserInfo}
    PopUp={PopUp}
  />
);

export default CartModal;
